import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import MicrosoftIcon from './Icons';

const MicrosoftLoginButton = function MicrosoftLoginButton({
  label = 'Sign in with Microsoft',
  loginUrl,
  ...props
}) {
  return (
    <form action={loginUrl} method="post">
      <Button
        type="submit"
        variant="outlined"
        sx={{
          border: '2px solid #d6d6d6',
          color: 'greys.title',
          textTransform: 'none',
          borderRadius: '10px',
          '&:hover': {
            borderWidth: '2px',
            backgroundColor: 'white.main',
          },
        }}
        fullWidth
        size="medium"
      >
        <MicrosoftIcon {...props} />
        <span>{label}</span>
      </Button>
    </form>
  );
};

MicrosoftLoginButton.propTypes = {
  label: PropTypes.string,
  loginUrl: PropTypes.string.isRequired,
};

export default MicrosoftLoginButton;
